import React from "react";
import { Box, Typography } from "@mui/material";
import logo from "./assets/logo.png";

const Loading = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#000000",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2.5,
      }}
    >
      <Box sx={{ animation: "breathe 2.4s ease-in-out infinite" }}>
        <img
          src={logo}
          alt="DiskHub Technologies"
          width={96}
          height={96}
          style={{ borderRadius: 18 }}
        />
      </Box>

      <Box sx={{ display: "flex", gap: 0.8, alignItems: "center" }}>
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            sx={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              bgcolor: "#1FD62E",
              "@keyframes dotBounce": {
                "0%, 80%, 100%": { transform: "scale(0.6)", opacity: 0.4 },
                "40%": { transform: "scale(1)", opacity: 1 },
              },
              animation: `dotBounce 1.2s ease-in-out ${i * 0.2}s infinite`,
            }}
          />
        ))}
      </Box>

      <Typography
        variant="caption"
        sx={{
          color: "#64748B",
          letterSpacing: "0.15em",
          textTransform: "uppercase",
          fontSize: "0.7rem",
        }}
      >
        Loading
      </Typography>
    </Box>
  );
};

export default Loading;
